/**
 * 文档左侧导航tree
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import Icon from "../../Icon";
import { message, Tree, Dropdown } from "antd";
import "./index.less";
import { useTranslation } from "../../context";
import { useHistory, useLocation } from "react-router-dom";
const { DirectoryTree, TreeNode } = Tree;
import api from "../../api";
import { debounce, floor, isLength } from "lodash";
import { folderType, folderTypeEnum, FolderTypeNames } from "../../config/permissions.config";
import events from "../../context/events";
import folderPng from "@/assets/img/folder.png";
import folderSharePng from "@/assets/img/folder-share.png";
import Item from "antd/lib/list/Item";
import { getJoySpaceDucc, isMySpace, JoyspaceRouterMap } from "../../util";
import qs from "query-string";
import { connect } from "dvajs";
import { JoyspaceState } from "@/models/joyspace";

import ScrollView from "@/baseComponents/ScrollView";
import { setTimeout } from "timers";
// import { ICategoryBase } from "../../types";
import { RootTreeNodeTitle, LeafTreeNodeTitle } from "./TagsTreeNodeTitle";
import { openModalTextBox } from "../ModalTextBox";
import { FileType } from "../../types";
interface navItem {
  id: string;
  name?: string;
  isLeaf?: boolean;
  children?: navItem[];
  isShared?: boolean;
  [key: string]: any;
}
interface Props {
  getFolderInfoById: Function;
  setCurrentRouterInfoById: Function;
  treeDataInfo: any;
  expandedKeys: any[];
  setExpandedKeys: Function;
  selectedKeys: [];
  setSelectedKeys: Function;
  changeFolderInfoById: Function;
  freshLeftTreeByFolderById: Function;
  updataTreeFolderById: Function;
  folderInfoMap: any;
  batchUpdataTreeFolderByIds: Function;
  getTags: Function;
  setCurrentPath: Function;
}
type IProps = Readonly<JoyspaceState & Props>;

function NavTree(props: IProps) {
  const {
    getFolderInfoById,
    treeDataInfo,
    expandedKeys,
    setExpandedKeys,
    selectedKeys,
    setSelectedKeys,
    setCurrentRouterInfoById,
    changeFolderInfoById,
    updataTreeFolderById,
    freshLeftTreeByFolderById,
    folderInfoMap,
    batchUpdataTreeFolderByIds,
    getTags,
    setCurrentPath
  } = props;
  const location = useLocation();
  const history = useHistory();
  const lang = useTranslation();
  const [width, setWidth] = useState(210);
  const [modalVisible, changeModalVisible] = useState(false);
  const scrollRef: any = useRef(null);
  useEffect(() => {
    const query = qs.parse(location.search);
    if (query.categoryId) {
      setCurrentRouterInfoById(query.categoryId);
    } else {
      if (isMySpace(location.pathname)) {
        setCurrentRouterInfoById("myspace");
      } else if (location.pathname.includes("teamspace")) {
        setCurrentRouterInfoById(folderType.SHARE);
      } else {
        setCurrentRouterInfoById(null);
      }
    }
  }, [location, setCurrentRouterInfoById]);
  useEffect(() => {
    return () => {
      setCurrentRouterInfoById(null);
    };
  }, [setCurrentRouterInfoById]);
  const leftNavSize = (width: any) => {
    if (!width) return;
    setWidth(width);
  };
  const doExpandKey = useCallback(
    (expandedKey: string) => {
      //   console.log("expandedKeys111", expandedKeys, expandedKey);
      const useExpandedKeys: any[] = [...expandedKeys];
      if (!expandedKeys.includes(expandedKey)) {
        useExpandedKeys.push(expandedKey);
        setExpandedKeys(useExpandedKeys);
      }
    },
    [expandedKeys, setExpandedKeys]
  );
  useEffect(() => {
    const changeFolderInfoByIdFuc = (id: string, name: string, desc = "") => {
      changeFolderInfoById({
        id,
        name,
        desc
      });
    };
    const deleteFolderByIdFuc = (id: string, toId = "") => {
      updataTreeFolderById(id, toId);
    };
    const freshLeftTreeByFolderByIdFuc = (id: string) => {
      freshLeftTreeByFolderById({ id });
    };
    const batchDeleteFolderByIds = (ids = [], toId = "") => {
      batchUpdataTreeFolderByIds(ids, toId);
    };
    events.on("changeFolderInfoById", changeFolderInfoByIdFuc);
    events.on("deleteFolderById", deleteFolderByIdFuc);
    events.on("batchDeleteFolderById", batchDeleteFolderByIds);
    events.on("freshLeftTreeByFolderById", freshLeftTreeByFolderByIdFuc);
    events.on("left-nav-resize", leftNavSize);
    return () => {
      events.off("changeFolderInfoById", changeFolderInfoByIdFuc);
      events.off("deleteFolderById", deleteFolderByIdFuc);
      events.off("batchDeleteFolderById", batchDeleteFolderByIds);
      events.off("freshLeftTreeByFolderById", freshLeftTreeByFolderByIdFuc);
      events.off("left-nav-resize", leftNavSize);
    };
  }, [
    changeFolderInfoById,
    updataTreeFolderById,
    freshLeftTreeByFolderById,
    batchUpdataTreeFolderByIds
  ]);
  useEffect(() => {
    events.on("autoExpandTree", doExpandKey);
    return () => {
      events.off("autoExpandTree", doExpandKey);
    };
  }, [doExpandKey]);
  const doAutoScroll = useCallback((data: { scrollTop: number }) => {
    const { scrollTop } = data;
    const scrollTop1 = scrollRef.current.getScrollTop();
    scrollRef.current.scrollTop(scrollTop1 - scrollTop || 0);
  }, []);
  useEffect(() => {
    events.on("tree-autoScroll", doAutoScroll);
    return () => {
      events.off("tree-autoScroll", doAutoScroll);
    };
  }, [doAutoScroll]);
  const tipContent = (id: string) => {
    return (
      <div className="joyspace-tip-wrapper">
        {id === "myspace" && (
          <div className="tip-item">
            <div className="tip-title">我的文件</div>
            <div className="tip-content">
              此处存放您的个人文件，只有您可查看、编辑和管理此处的文件夹和文档。
            </div>
          </div>
        )}
        {id === "teamRoot" && (
          <div className="tip-item">
            <div className="tip-title">共享文件</div>
            <div className="tip-content">
              此处可以查看所有共享给您的文件和文件夹。
              <br />
              共享文件夹的协作者可以直接查阅或编辑文件夹内的所有内容，无需逐一分享。
            </div>
          </div>
        )}
      </div>
    );
  };
  // const [treeData, setTreeData] = useState<navItem[]>(navlinks);
  // 展开的回调 因为现在每次点击都重新请求数据子如果不关闭会有bug
  // const onExpand = (expandedKey: any, obj: any) => {
  //     if (obj.expanded) {
  //         setExpandedKeys(expandedKey);
  //     } else {
  //         const arr: any = [];
  //         expandedKey.forEach((itemKey: any) => {
  //             if (itemKey === obj.node.key) {
  //                 arr.push(obj.node.key);
  //             }
  //             getChildExpandKey(itemKey, obj.node.children, arr);
  //         });
  //         let currentKey = expandedKey.filter(function (val: any) {
  //             return arr.indexOf(val) === -1;
  //         });
  //         setExpandedKeys(currentKey);
  //     }
  // };
  const onExpand = useCallback(
    (expandedKey: any, obj: any) => {
      if (obj.expanded) {
        setExpandedKeys(expandedKey);
      } else {
        const arr: any = [];
        expandedKey.forEach((itemKey: any) => {
          if (itemKey === obj.node.key) {
            arr.push(obj.node.key);
          }
          getChildExpandKey(itemKey, obj.node.children, arr);
        });
        let currentKey = expandedKey.filter(function (val: any) {
          return arr.indexOf(val) === -1;
        });
        setExpandedKeys(currentKey);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setExpandedKeys]
  );
  function getChildExpandKey(expandedKey: any, child: any, arr: any) {
    if (child) {
      child.forEach((item: any) => {
        if (expandedKey === item.key) {
          arr.push(item.key);
        }
        getChildExpandKey(expandedKey, item.children, arr);
      });
    }
  }
  // 需要根据类型来区分是共享文件还是我的文件
  const changeRouter = useCallback(
    (type: number | string, categoryId: string) => {
      let realPath = "";
      if (type === folderTypeEnum.MY) {
        realPath = `/joyspace/myspace?categoryId=${categoryId}`;
      } else if (type === folderTypeEnum.SHARE) {
        realPath = `/joyspace/teamspace?categoryId=${categoryId}`;
      } else if (type === FolderTypeNames.TAGS) {
        if (!folderInfoMap[categoryId] || folderInfoMap[categoryId].isNew) {
          return;
        }
        realPath = `/joyspace/mytags?tagId=${categoryId}&random=${Math.floor(Math.random() * 100000)}`;
      }
      history.push(realPath);
      setCurrentPath(realPath);
      // setCurrentRouterInfoById(categoryId);
    },
    [folderInfoMap]
  );

  const onSelect = useCallback(
    (selectedKeys: any, e: any) => {
      const { node } = e;
      if (node["data-type"] === FolderTypeNames.TAGS) {
        onLoadData({ key: FolderTypeNames.TAGS });
      }
      if (selectedKeys.length > 0) {
        setSelectedKeys(selectedKeys);
        // return;
      }

      if (node.className === "first-level-node" || node.className?.includes("first-level-node")) {
        setCurrentPath("");
        return;
      }
      changeRouter(node["data-type"], node.key);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setSelectedKeys, changeRouter]
  );
  const changeRightUrl = (item: navItem) => {
    // events.emit('onChangeMenu', {
    //     sort: Sort.UpDateTime,
    //     order: Order.DESC,
    // });
    history.push(item.to);


  };
  // const onCreatRouter = function (item: any) {
  //     events.emit('onCreatRouter', {
  //         fullName: item.full_name,
  //         fullPath: item.full_path,
  //         description: item.description,
  //         permissionType: item.permission_type,
  //     });
  // };
  const IconTitleRight = <Icon type="iconic_pc_sanjiao_yundoc" className="tree-icon-expand" />;

  function onLoadData({ key, children }: any) {
    return new Promise<void>((resolve) => {
      if (key === FolderTypeNames.TAGS) {
        getTags(key).then(() => {
          resolve();
        });
      } else {
        getFolderInfoById(key).then(() => {
          resolve();
          events.emit("tree-loadData", key);
        });
      }
    });
  }
  const addFileInfo = useCallback((folderId: string, type: FileType, info: any) => {
    const id = info?.id;
    if (!id || !type) {
      console.error("id or type not null");
      return;
    }
    events.emit("list.reload", { folderId });
  }, []);
  // teamRoot/root
  const createFolder = (pfolderId: string) => {
    openModalTextBox({
      title: lang("c.categoriesPicker.create"),
      onOk: (value, close) => {
        api.categories.create(pfolderId || "", value).then((res) => {
          if (res?.data) {
            message.success(lang("common.success"));
            close();
            setTimeout(() => {
              const path = `/joyspace/${
                pfolderId === "root" ? "myspace" : "teamspace"
              }?categoryId=${res.data.id}`;
              console.log("path", path);
              history.push(path);
            }, 200);
          } else {
            message.error(res.status || lang("common.fail"));
          }
        });
      }
    });
  };
  const CreateNode = useCallback((pfolderId) => {
    return (
      <TreeNode
        data-drag="stop"
        className="node-create"
        selectable={false}
        title={() => {
          return (
            <div
              className="nav-tree-item-title"
              id={"create" + pfolderId}
              // onDragOver={(e) => {
              //   e.preventDefault();
              //   message.info("lalal");
              // }}
              onClick={() => {
                createFolder(pfolderId === "myspace" ? "root" : pfolderId);
              }}
            >
              <div className="nav-item-content">
                <Icon type="iconquanjuchuangjian" className="icon" />
                <div className="nav-item-name" style={{ width: width - 1 * 24 - 24 - 24 - 32 }}>
                  新建文件夹
                </div>
              </div>
            </div>
          );
        }}
        key={"create" + pfolderId}
        isLeaf={true}
      />
    );
  }, []);
  function renderTree(data: navItem[], folderInfoMap: any, level = 0) {
    return data.map((item: any) => {
      // 第一层路由跳转
      if (item.level === 0) {
        let theclstag = item.clstag ? { clstag: item.clstag } : {};
        if (item.type === FolderTypeNames.TAGS) {
          return (
            <TreeNode
              className="first-level-node"
              data-drag={
                item.id === "myspace" || item.id === "teamRoot" ? "tree-" + item.id : "stop"
              }
              title={() => (
                <RootTreeNodeTitle
                  loadData={onLoadData}
                  item={item}
                  theclstag={theclstag}
                  lang={lang}
                  width={width}
                />
              )}
              key={item.id}
              isLeaf={item.isLeaf}
            >
              {item?.children && renderTree(item?.children || [], folderInfoMap)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            className={`${item.withSplit ? "tree-split " : ""}first-level-node`}
            data-drag={item.id === "myspace" || item.id === "teamRoot" ? "tree-" + item.id : "stop"}
            title={() => {
              return (
                <div
                  className="nav-tree-item-title"
                  // onDragOver={(e) => {
                  //   message.info("lalal");
                  //   console.log("drag111", e.dataTransfer.setData);
                  //   // 共享文件不能拖到我的文件 不用展开
                  //   // 文件不能拖到共享文件夹根部 但是需要展开
                  //   e.preventDefault();
                  // }}
                  // onDragLeave={(e) => {
                  //   e.preventDefault();
                  // }}
                  log-analysis-data={
                    "xtbj_jzb_joyspace_leftMenu_1676552595819|" +
                    `${[
                      null,
                      "myspace",
                      "teamRoot",
                      "collections",
                      "trashes",
                      "home",
                      "knowledge"
                    ].indexOf(item.id)}` // 埋点id：1-6 分别为我的文件、共享文件、收藏列表、回收站、首页、知识库
                  } //
                  {...theclstag}
                  id={item.id}
                  onClick={debounce(() => {
                    changeRightUrl(item);
                  }, 500)}
                >
                  <div className="nav-item-content">
                    <Icon type={item.icon} />
                    <div className="nav-item-name" style={{ width: `calc(${width} - 30%)` }}>
                      {lang(item.name)}
                    </div>
                    {(item.id === "myspace" || item.id === "teamRoot") && (
                      <Dropdown
                        overlay={tipContent(item.id)}
                        // trigger={['click']}
                        placement="topRight"
                      >
                        <Icon type="iconquanjutishi" className="tip" />
                      </Dropdown>
                    )}
                  </div>
                </div>
              );
            }}
            key={item.id}
            isLeaf={item.isLeaf}
          >
            (
            {(item.id === "myspace" || item.id === "teamRoot") &&
              item?.children?.length < 1 &&
              CreateNode(item.id)}
            {item?.children && renderTree(item?.children || [], folderInfoMap)}
          </TreeNode>
        );
      } else {
        const ownItem = folderInfoMap[item.id];
        if (!ownItem) return null;
        let layer = level;
        layer++;
        if (ownItem.type === FolderTypeNames.TAGS) {
          return (
            <TreeNode
              data-drag="stop"
              data-full_name={ownItem.full_name}
              data-full_path={ownItem.full_path}
              data-description={ownItem.description}
              data-permission_type={ownItem.permission_type}
              data-type={ownItem.type}
              title={() => {
                return (
                  <LeafTreeNodeTitle
                    onSelect={onSelect}
                    changeRightUrl={changeRightUrl}
                    ownItem={ownItem}
                    layer={layer}
                    width={width}
                    item={item}
                  />
                );
              }}
              key={ownItem.id}
              isLeaf={true}
            >
              {item?.children && renderTree(item?.children || [], folderInfoMap, layer)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            data-drag={"tree-" + ownItem.id}
            data-full_name={ownItem.full_name}
            data-full_path={ownItem.full_path}
            data-description={ownItem.description}
            data-permission_type={ownItem.permission_type}
            data-type={ownItem.type}
            title={() => {
              return (
                <div
                  className="nav-tree-item-title"
                  id={item.id}
                  // onDragOver={(e) => {
                  //   e.preventDefault();
                  //   message.info("lalal");
                  // }}
                >
                  <div className="nav-item-content">
                    <img
                      src={folderInfoMap[item.id].isShared ? folderSharePng : folderPng}
                      className="iconic-folder"
                    />
                    {/* <Icon type="iconapp_btn_folder" className="iconic-folder" /> */}
                    <div
                      className="nav-item-name"
                      style={{ width: width - layer * 24 - 24 - 24 - 32 }}
                    >
                      {ownItem.name}
                    </div>
                  </div>
                </div>
              );
            }}
            key={ownItem.id}
            isLeaf={false}
          >
            {item?.children && renderTree(item?.children || [], folderInfoMap, layer)}
          </TreeNode>
        );
      }
    });
  }
  const handleScrollFrame = (e: any) => {
    const event = e || window.event; // 解决浏览器兼容问题
    console.log("handleScrollFrame1111", event);
  };
  //   myspace-list-wrap tableWrapper
  return (
    <div className="joyspace-nav-tree-space ">
      <ScrollView nohorizontal={true} ref={scrollRef} onScrollFrame={handleScrollFrame}>
        <Tree
          blockNode
          loadData={onLoadData}
          icon={() => {
            return false;
          }}
          expandedKeys={expandedKeys}
          autoExpandParent
          // defaultExpandParent={false}
          switcherIcon={IconTitleRight}
          showIcon={false}
          loadedKeys={expandedKeys}
          selectedKeys={selectedKeys}
          onSelect={onSelect}
          onExpand={onExpand}
        >
          {treeDataInfo && renderTree(treeDataInfo, folderInfoMap, 0)}
        </Tree>
      </ScrollView>
    </div>
  );
}
function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    treeDataInfo: joyspace.treeDataInfo,
    expandedKeys: joyspace.expandedKeys,
    selectedKeys: joyspace.selectedKeys,
    folderInfoMap: joyspace.folderInfoMap,
    currentRouterInfo: joyspace.currentRouterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getFolderInfoById(data: any) {
      return dispatch({ type: "joyspace/getFolderInfoById", payload: { id: data } });
    },
    setExpandedKeys(data: any) {
      dispatch({ type: "joyspace/setExpandedKeys", payload: data });
    },
    setSelectedKeys(data: any) {
      dispatch({ type: "joyspace/setSelectedKeys", payload: data });
    },
    setCurrentRouterInfoById(data: any) {
      dispatch({ type: "joyspace/setCurrentRouterInfoById", payload: data });
    },
    freshLeftTreeByFolderById(data: any) {
      return dispatch({ type: "joyspace/freshLeftTreeByFolderById", payload: { ...data } });
    },
    updataTreeFolderById(id: any, toId = "") {
      return dispatch({ type: "joyspace/updataTreeFolderById", payload: { id, toId } });
    },
    changeFolderInfoById(data: any) {
      return dispatch({ type: "joyspace/changeFolderInfoById", payload: { ...data } });
    },
    batchUpdataTreeFolderByIds(ids = [], toId = "") {
      return dispatch({ type: "joyspace/batchUpdataTreeFolderByIds", payload: { ids, toId } });
    },
    getTags(data: any) {
      return dispatch({ type: "joyspace/getTags", payload: { ...data } });
    },
    setCurrentPath(data: any) {
      return dispatch({ type: "joyspace/setCurrentPath", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(NavTree);
